import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgeGlobalRoute: InvariantJiraRoute = {
	name: 'forge-spa-global',
	path: '/jira/apps/:appId/:envId/:route?',
};
